import { send } from '../../../../../../../src/network/network';
import { type PaginatedProductSubscriptionCustomerConfigList } from '../../../../../../../src/types/PaginatedProductSubscriptionCustomerConfigList';
import {
  type OrderDateParam,
  setOrderDateParam,
} from '../../../../../../../src/utils/orderDateParam';

export type PricingServiceCustomerProductSubscriptionCustomerConfigParams = {
  containerId?: number;
  is_staged?: number;
  limit?: number;
  offset?: number;
  origin?: number;
  orderDate?: OrderDateParam;
};

export const getPricingServiceCustomerProductSubscriptionCustomerConfigPath = (
  params: PricingServiceCustomerProductSubscriptionCustomerConfigParams
) => {
  const queryParams = new URLSearchParams();

  if (params.containerId !== undefined) {
    queryParams.append('containerId', params.containerId.toString());
  }

  if (params.is_staged !== undefined) {
    queryParams.append('is_staged', params.is_staged.toString());
  }

  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit.toString());
  }

  if (params.offset !== undefined) {
    queryParams.append('offset', params.offset.toString());
  }

  if (params.origin !== undefined) {
    queryParams.append('origin', params.origin.toString());
  }

  setOrderDateParam(queryParams, params.orderDate);

  return `/api/v2/pricing_service/customers/self/product_subscription_customer_config/?${queryParams.toString()}`;
};

export async function getApiV2PricingServiceCustomersCustomerIdProductSubscriptionCustomerConfig(
  params: PricingServiceCustomerProductSubscriptionCustomerConfigParams
) {
  return await send<PaginatedProductSubscriptionCustomerConfigList>({
    path: getPricingServiceCustomerProductSubscriptionCustomerConfigPath(
      params
    ),
    method: 'GET',
  });
}
